import { render } from "./ks-bio-chapter.vue?vue&type=template&id=1976b906"
import script from "./ks-bio-chapter.vue?vue&type=script&lang=js"
export * from "./ks-bio-chapter.vue?vue&type=script&lang=js"

import "./ks-bio-chapter.vue?vue&type=style&index=0&id=1976b906&lang=css"
script.render = render

export default script